import { mapGetters, mapActions } from 'vuex'
import TableCustomSort from '@/components/table-custom-sort/table-custom-sort'
import IcEdit from '@/assets/svg/ic-edit.svg?inline'

export default {
  name: 'SettingsTable',
  components: {
    TableCustomSort,
    IcEdit
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      selectedManufactoryIds: 'globalSettings/getSelectedManufactoryIds',
      schema: 'globalSettings/getSchema'
    }),
    tableColumns() {
      const baseColumns = [
        {
          field: 'checkbox',
          label: '',
          sortable: false
        },
        {
          field: 'title',
          label: 'Название производства',
          sortable: true
        }
      ]

      const settingColumns = this.schema.map(col => ({
        field: `setting_${col.key}`,
        label: col.title,
        sortable: false
      }))

      return [...baseColumns, ...settingColumns, { field: 'filler', label: '', sortable: false }]
    },
    isAllSelected() {
      return this.data.length > 0 &&
        this.selectedManufactoryIds.length === this.data.length
    },
    isSomeSelected() {
      return this.selectedManufactoryIds.length > 0 && !this.isAllSelected
    }
  },
  methods: {
    ...mapActions({
      toggleManufactorySelection: 'globalSettings/toggleManufactorySelection',
      selectAllManufactories: 'globalSettings/selectAllManufactories',
      clearSelection: 'globalSettings/clearSelection'
    }),

    isRowSelected(manufactureId) {
      return this.selectedManufactoryIds.includes(manufactureId)
    },

    onToggleRow(manufactureId) {
      this.toggleManufactorySelection(manufactureId)
    },

    onToggleSelectAll() {
      if (this.isAllSelected) {
        this.clearSelection()
      } else {
        this.selectAllManufactories()
      }
    },

    getColumnByKey(key) {
      return this.schema.find(col => col.key === key)
    },

    getSettingDisplay(row, key) {
      const value = row.settings?.[key]
      if (value === undefined || value === null) return null
      const col = this.getColumnByKey(key)
      return col ? `${value} ${col.measure_unit}` : value
    },

    onEditSetting(row, settingKey) {
      this.$emit('edit-cell', {
        manufactureId: row.manufacture_id,
        settingKey
      })
    },

    onEditRow(row) {
      this.$emit('edit-row', {
        manufactureId: row.manufacture_id
      })
    }
  }
}
